import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const dashboardHeading: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'dsgnsys_DashboardHeading_dataBinding_panelTitle',
    helpId: 'd06f6fff-5645-4d78-82a8-cfddd2e321df',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'DashboardHeadingRole',
      bindings: [
        {
          title: 'dsgnsys_DashboardHeading_dataBinding_text_label',
          prop: 'text',
          supportedFieldTypes: [FieldType.text, FieldType.richText],
          defaultFieldType: FieldType.text,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
